import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Carousel from './components/Carousel';
import IndexSection from './components/IndexSection';
import Cards from './components/Cards';
import FAQ from './components/FAQ';
import Media from './components/Media';
import Updates from './components/Updates';
import Comments from './components/Comments';
import About from './components/About';
import Contact from './components/Contact';
import AppSection from './components/AppSection';
import Ranking from './components/Ranking';
import Topics from './components/Topics';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Carousel />
        <IndexSection />
        <Cards />
        <FAQ />
        <Media />
        <Updates />
        <Comments />
        <About />
        <Contact />
        <AppSection />
        <Ranking />
        <Topics />
      </main>
      <Footer />
    </>
  );
}